import { KIND } from 'baseui/button'
import { Delete } from 'baseui/icon'
import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import IconPhoneCallback from '@/shared/icons/NewDesign/IconPhoneCallback'
import { CallbackReminderCardView } from '../useCallbackReminderPopup'
import {
  Card,
  CardBody,
  CardHeader,
  CardSubtitle,
  CardTitle,
  CloseButton,
  CustomerName,
  CustomerPhone,
  HeaderText,
  IconBubble,
} from './styled-components'

type CallbackReminderCardProps = Omit<CallbackReminderCardView, 'id'>

const CallbackReminderCard = ({
  title,
  subtitle,
  customer,
  phone,
  isLate,
  hasContact,
  isDismissing,
  closeLabel,
  openContactLabel,
  onClose,
  onOpenContact,
}: CallbackReminderCardProps) => (
  <Card data-testid='callback-reminder-card'>
    <CardHeader>
      <IconBubble>
        <IconPhoneCallback size={18} color='currentColor' />
      </IconBubble>
      <HeaderText>
        <CardTitle $isLate={isLate}>{title}</CardTitle>
        <CardSubtitle hidden={isLate}>{subtitle}</CardSubtitle>
      </HeaderText>
      <CloseButton type='button' aria-label={closeLabel} title={closeLabel} disabled={isDismissing} onClick={onClose}>
        <Delete size={20} />
      </CloseButton>
    </CardHeader>
    <CardBody>
      <CustomerName hidden={!customer}>{customer}</CustomerName>
      <CustomerPhone hidden={!phone}>{phone}</CustomerPhone>
      {/* @ts-expect-error SDButton is a JS component */}
      <SDButton kind={KIND.primary} block disabled={isDismissing} hidden={!hasContact} onClick={onOpenContact}>
        {openContactLabel}
      </SDButton>
    </CardBody>
  </Card>
)

export default CallbackReminderCard
